export enum VerificationChannelEnum {
  SMS = "sms",
  WHATSAPP = "whatsapp",
}